var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('settings-card',{attrs:{"config":_vm.config}},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.settings}},[_vm._v("去设置")])],1),_c('warehouse-management-modal',{ref:"management",attrs:{"enable":_vm.enable,"operType":_vm.config.operType,"title":_vm.config.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }